{
  "el": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Επεξεργασία λεπτομερειών",
          "reminder": "Επεξεργασία υπενθυμίσεων"
        },
        "closeAllRows": "Κλείσιμο όλων των γραμμών",
        "deleteCount": "Πρόκειται να διαγράψεις {count} δόση. Θέλεις σίγουρα να συνεχίσεις; | Πρόκειται να διαγράψεις {count} δόσεις. Θέλεις σίγουρα να συνεχίσεις;",
        "delete_installments": "Διαγραφή δόσης | Διαγραφή δόσεων",
        "edit": "Επεξεργασία",
        "newInstallment": "Νέο πρόγραμμα δόσεων",
        "openAllRows": "Άνοιγμα όλων των γραμμών",
        "publish": "Δημοσίευση",
        "publishCustomer": "Δημοσίευση...",
        "save": "Ενημέρωση",
        "unpublish": "Κατάργηση δημοσίευσης",
        "updateStatus": "Ενημέρωση κατάστασης",
        "uploadInvoice": "Ανέβασμα τιμολογίου"
      },
      "attributes": {
        "amount": "Ποσό",
        "customer": "Πελάτης",
        "description": "Περιγραφή",
        "due_date": "Προθεσμία",
        "group_name": "Πρόγραμμα δόσεων",
        "paid_at": "Πληρώθηκε στις",
        "status_deadline": "Κατάσταση",
        "unit": "Ακίνητο"
      },
      "edit_actions": {
        "edit_amount": "Ποσά",
        "edit_deadline": "Προθεσμία",
        "edit_description": "Περιγραφή",
        "edit_status": "Κατάσταση"
      },
      "labels": {
        "cantEditFractions": "Όρισε την κατάσταση της δόσης σε «Πρόχειρη» για να επεξεργαστείς τους κανόνες.",
        "changeStatusRequested": "Αλλαγή δόσεων από κατάσταση «Πρόχειρη» σε «Τιμολογημένη»",
        "changeVisibility": "Αλλαγή ορατότητας...",
        "change_amounts": "Αλλαγή ποσών",
        "clear_due_date": "Εκκαθάριση προθεσμίας για όλες τις επιλεγμένες δόσεις",
        "clear_paid_at": "Εκκαθάριση ημερομηνίας πληρωμής για όλες τις επιλεγμένες δόσεις",
        "countEdit": "Επεξεργασία δόσης για 1 ακίνητο | Επεξεργασία δόσης για {count} ακίνητα",
        "created_at": "Δημιουργήθηκε {created_at}",
        "deleteExplanation": "Όλες οι δόσεις και τα τιμολόγια θα διαγραφούν οριστικά από την πλατφόρμα.",
        "deleteExplanationGroup": "Επειδή θέλεις να διαγράψεις όλες τις δόσεις αυτού του προγράμματος δόσεων, θα διαγραφεί και το ίδιο το πρόγραμμα.",
        "details": "Λεπτομέρειες",
        "edit": "Επεξεργασία δόσεων",
        "editDueDate": "Επεξεργασία προθεσμίας",
        "editInstallmentTerm": "Επεξεργασία δόσης",
        "excl_vat": "χωρίς ΦΠΑ",
        "giveNewAmount": "Δώσε νέο ποσό",
        "goToUnitInstallments": "Μετάβαση στις δόσεις του ακινήτου",
        "installmentNoteExplainer": "Αυτή η σημείωση είναι ορατή μόνο στα μέλη της ομάδας.",
        "installment_categories": "Προσαρμοσμένες κατηγορίες",
        "invoices": "1 τιμολόγιο | {count} τιμολόγια",
        "new_installment_fraction_category": "Κατηγορία",
        "noDeadline": "Χωρίς προθεσμία",
        "notPublished": "Μη δημοσιευμένο",
        "paid": "Πληρωμένη",
        "published": "Δημοσιευμένο",
        "publishedCustomer": "Δημοσιευμένο για τον πελάτη",
        "publishingForCustomers": "Θέλεις σίγουρα να συνεχίσεις;",
        "selectOne": "Επίλεξε τουλάχιστον 1 δόση",
        "selected": "Επιλέχθηκε {selected} δόση. | Επιλέχθηκαν {selected} δόσεις.",
        "setDueDate": "Ορισμός προθεσμίας",
        "statusExplained": "Τι σημαίνει κάθε κατάσταση δόσης;",
        "status_click_to_change": "Κάνε κλικ για αλλαγή",
        "status_deadline": "Κατάσταση",
        "statuses": {
          "draft": "Πρόχειρη",
          "expected": "Αναμενόμενη",
          "overdue": "Εκπρόθεσμη",
          "paid": "Πληρωμένη",
          "requested": "Τιμολογημένη"
        },
        "toBePaid": "Προς πληρωμή",
        "total": "Σύνολο",
        "unitInstallmentsWillBeShownHere": "Εδώ θα εμφανίζονται οι δόσεις του ακινήτου",
        "unpublishingForCustomers": "Θα καταργηθεί η δημοσίευση των δόσεων για τον πελάτη. Θέλεις σίγουρα να συνεχίσεις;",
        "updateStatusCount": "Ενημέρωση κατάστασης για 1 δόση | Ενημέρωση κατάστασης για {count} δόσεις",
        "uploadInvoiceCount": "Ανέβασμα τιμολογίου για 1 δόση | Ανέβασμα τιμολογίου για {count} δόσεις",
        "uploadInvoiceUnit": "Ανέβασμα τιμολογίου για {unit_name}",
        "vat": "ΦΠΑ",
        "vat_with_percentage": "ΦΠΑ {percentage}%",
        "view_list": "Λίστα"
      },
      "legend": {
        "installmentDraft": "Πρόχειρη δόση",
        "installmentDraftAfterDueDate": "Πρόχειρη δόση",
        "installmentExpired": "Η προθεσμία έληξε",
        "installmentPaid": "Η δόση έχει ήδη πληρωθεί",
        "installmentPaidAfterDue": "Η δόση πληρώθηκε μετά την προθεσμία",
        "installmentRequested": "Τιμολογημένη",
        "reminders": {
          "active": "Έχει οριστεί τουλάχιστον 1 υπενθύμιση",
          "none": "Δεν έχει οριστεί καμία υπενθύμιση"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Εδώ θα εμφανίζονται όλα τα έγγραφα των δόσεων.",
            "title": "Δεν υπάρχουν ακόμη έγγραφα"
          },
          "new": {
            "subtitle": "Σύντομα θα προστεθούν νέες δόσεις"
          }
        }
      },
      "sort_options": {
        "due_date": "Προθεσμία",
        "due_date asc": "Πιο μακρινή προθεσμία πρώτα",
        "due_date desc": "Πιο κοντινή προθεσμία πρώτα",
        "group_name": "Όνομα",
        "group_name asc": "Όνομα Α → Ω",
        "group_name desc": "Όνομα Ω → Α",
        "status": "Κατάσταση",
        "status asc": "Κατάσταση Α → Ω",
        "status desc": "Κατάσταση Ω → Α",
        "updated_at asc": "Λιγότερο πρόσφατα ενημερωμένα",
        "updated_at desc": "Πρόσφατα ενημερωμένα"
      },
      "validation": {
        "needNumber": "Χρειάζεται αριθμός (π.χ. 8400.5)"
      }
    }
  }
}
